import {BuyFeatureView} from '@gongxigames/framework/slot/modules/buyFeature/BuyFeatureView';
import {BuyFeatureModule} from '@gongxigames/framework/slot/modules/buyFeature/BuyFeatureModule';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels/ReelsEvents';
import {BuyFeatureStates} from '@gongxigames/framework/slot/modules/buyFeature/BuyFeatureStates';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';

export class BuyFeatureBasicState extends ModuleState<BuyFeatureView, BuyFeatureModule> {
    public static readonly REASON_NAME: symbol = Symbol('BuyFeatureBasicState');

    public onEnterState(): void {
        this.module.enableShowPopupButtonByName(BuyFeatureBasicState.REASON_NAME);
    }

    public onLeaveState(): void {
        this.module.disableShowPopupButtonByName(BuyFeatureBasicState.REASON_NAME);
    }

    protected setupEvents(): void {
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.goToWaiting.bind(this));
    }

    protected goToWaiting(): void {
        this.module.gotoState(BuyFeatureStates.WAITING);
    }
}
